import React from 'react'
import { FaBuilding, FaUsers } from 'react-icons/fa'
import { useParams, useNavigate } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_MANUFACTURE_BY_ID, GET_MANUFACTURE } from '../../apollo/queries/getManufacture'
import MainLayout from '../../components/Layout'
import Button from '../../components/atoms/Buttons'
import { BeatLoader } from 'react-spinners'
import CatalogMeasurements from './CatalogMeasurements'
import ManufacturerBusinessInfo from '../../components/ManufacturerBusinessInfo/ManufacturerBusinessInfo'
import ManufacturerUsers from './ManufacturerUsers'

function ManufacturerDetails() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = React.useState('profile')
  console.log(id)
  const { data, loading, error } = useQuery(GET_MANUFACTURE_BY_ID, {
    variables: { id },
    skip: !id,
  })

  const manufacturer = data?.getManufacturerById

  // Parse business form data
  const businessForm = React.useMemo(() => {
    if (manufacturer?.manufacturerObject?.businessForm) {
      try {
        return JSON.parse(manufacturer.manufacturerObject.businessForm)
      } catch (error) {
        console.error('Error parsing business form:', error)
        return null
      }
    }
    return null
  }, [manufacturer?.manufacturerObject?.businessForm])

  if (loading) {
    return (
      <MainLayout>
        <div className="flex items-center justify-center h-64">
          <BeatLoader color={'#2b364b'} />
        </div>
      </MainLayout>
    )
  }

  if (error) {
    return (
      <MainLayout>
        <div className="flex flex-col items-center justify-center h-64">
          <h2 className="text-xl font-semibold text-red-600 mb-4">
            Error loading manufacturer details
          </h2>
          <p className="text-gray-600 mb-4">{error.message}</p>
          <Button
            onClick={() => navigate('/manufacturers')}
            className="create-saddle-btn cursor-pointer"
          >
            Back
          </Button>
        </div>
      </MainLayout>
    )
  }

  if (!manufacturer) {
    return (
      <MainLayout>
        <div className="flex flex-col items-center justify-center h-64">
          <h2 className="text-xl font-semibold text-gray-600 mb-4">
            Manufacturer not found
          </h2>
          <Button
            onClick={() => navigate('/manufacturers')}
            className="create-saddle-btn cursor-pointer"
          >
            Back
          </Button>
        </div>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 pb-4 border-b border-gray-100 gap-4">
        <div>
          <h1 className="admin-dashboard !leading-tight mb-2">Manufacturer Details</h1>
          <p className="text-gray-500 font-montserrat text-sm">Manage business profile, catalog, and team access.</p>
        </div>
        <Button
          onClick={() => navigate('/manufacturers')}
          className="create-saddle-btn cursor-pointer !w-auto !h-[40px] px-6 !py-0 flex items-center justify-center"
        >
          Back to List
        </Button>
      </div>

      <div className="inline-flex p-1.5 bg-[#f7f7f6] rounded-2xl mb-8 border border-gray-200/50 shadow-sm transition-all gap-2">
        <button
          onClick={() => setActiveTab('profile')}
          className={`flex items-center gap-3 px-6 py-3 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider font-montserrat transition-all duration-300 border-none outline-none focus:outline-none focus:ring-0 cursor-pointer ${activeTab === 'profile'
            ? 'bg-white text-[#2b364b] shadow-[0_4px_12px_rgba(0,0,0,0.08)]'
            : 'text-gray-500 bg-transparent hover:text-gray-700 hover:bg-white/50'
            }`}
        >
          <FaBuilding
            size={18}
            className={`transition-colors ${activeTab === 'profile' ? 'text-[#2b364b]' : 'text-gray-400'}`}
          />
          Profile & Catalog
        </button>
        <button
          onClick={() => setActiveTab('team')}
          className={`flex items-center gap-3 px-6 py-3 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider font-montserrat transition-all duration-300 border-none outline-none focus:outline-none focus:ring-0 cursor-pointer ${activeTab === 'team'
            ? 'bg-white text-[#2b364b] shadow-[0_4px_12px_rgba(0,0,0,0.08)]'
            : 'text-gray-500 bg-transparent hover:text-gray-700 hover:bg-white/50'
            }`}
        >
          <FaUsers
            size={18}
            className={`transition-colors ${activeTab === 'team' ? 'text-[#2b364b]' : 'text-gray-400'}`}
          />
          Team Members
        </button>
      </div>

      {activeTab === 'profile' && (
        <>
          {/* Business Information Section */}
          <ManufacturerBusinessInfo
            manufacturer={manufacturer}
            businessForm={businessForm}
          />

          {/* Catalog and Measurements Section */}
          <div className="bg-white rounded-lg shadow-md p-2 ">
            <h2 className="text-[24px] md:text-[32px] ml-3 font-semibold text-[var(--Dark-Blue---Primary,#2b364b)] font-barlowcondensed uppercase">
              Update Catalog and Measurements
            </h2>
            <CatalogMeasurements manufacturer={manufacturer} />
          </div>
        </>
      )}

      {activeTab === 'team' && (
        <ManufacturerUsers manufacturer={manufacturer} />
      )}
    </MainLayout>
  )
}

export default ManufacturerDetails
